// extracted by mini-css-extract-plugin
module.exports = {"warning":"CreneauLigne_warning__1srr0"};